// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format5 } from '../../constants';

import { format9 } from '../../constants';

/** Bosnia & Herzegovina */
const BA: PhoneNumberData = [387, 'BA', 8, format5, 9, format9];

export default BA;
